// Copyright (c) 2021, Oracle and/or its affiliates. All rights reserved.
// Licensed under the Universal Permissive License v 1.0 as shown at http://oss.oracle.com/licenses/upl.
define('NVT.membershipdirectory.Collection.View', [
    'SCCollectionView',
    'NVT.membershipdirectory.Collection',
    'membershipdirectory.Details.View',
    'membershipdirectory_collection.tpl',
    'jQuery',
    'Utils'
], function (
    SCCollectionViewModule,
    MymembershipdirectoryCollection,
    membershipdirectoryDetailsView,
    membershipdirectory_collection_tpl,
    jQuery,
    Utils
) {
    'use strict';

    var SCCollectionView = SCCollectionViewModule.SCCollectionView;


    function nvtMembershipDirectoryCollectionView (options) {
        SCCollectionView.call(this, options.collection);
    
        this.application = options.application;
        this.collection = new MymembershipdirectoryCollection([], options);
        this.template = membershipdirectory_collection_tpl;
      }

      nvtMembershipDirectoryCollectionView.prototype = Object.create(SCCollectionView.prototype);
      nvtMembershipDirectoryCollectionView.prototype.constructor = nvtMembershipDirectoryCollectionView;

      // nvtMembershipDirectoryCollectionView.prototype.getCellViewInstance = function (model) {
      //   var params_options = Utils.parseUrlOptions(this.application);
      //   return new membershipdirectoryDetailsView({
      //     application: this.application,
      //     model: model,
      //     page: params_options.page || 1
      //   })
      // }
    
      nvtMembershipDirectoryCollectionView.prototype.getCellViewsPerRow = function () {
        return 1;
      }

      nvtMembershipDirectoryCollectionView.prototype.render = function () {
        var self = this;
        var params_options = Utils.parseUrlOptions(this.application);
        var parameters = {};
            parameters['page'] = params_options.page || 1;   
            if(params_options.perpage){
              parameters['per_page'] = params_options.perpage;    
            } else{
              parameters['per_page'] = 25;    
            }

        this.collection.fetch({data: parameters, reset: true}).done(function () {
          SCCollectionView.prototype.render.call(self);
        })
      }
    
      nvtMembershipDirectoryCollectionView.prototype.getContext = function () {
        return {}
      }
    
      return nvtMembershipDirectoryCollectionView;

})
